import {Card, Stack, CardContent, useTheme, useMediaQuery, Box, Typography, Table, TableContainer, TableHead, TableBody, TableRow, TableCell } from '@mui/material';

const IndependentExpenditureTable = (): JSX.Element => {
    const theme = useTheme();
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));

    const reports = [
        {
            report: '7-day Report',
            description: 'Independent expenditure reports are due within 7 business days after the goods or services are utilized to advocate for the election or defeat of a clearly identified candidate. Reports are required if more than $250 is spent, in the aggregate, in the calendar year.',
        },
        {
            report: '24-hour Report',
            description: 'Independent expenditure reports are due within 24 hours for any independent expenditure of more than $250 (in the aggregate) that is utilized after the 10th day, but more than 24 hours before the date of an election.',
        },
    ];


    return (
        <Box>

            {!isSM ?
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><b>Report</b></TableCell>
                                <TableCell><b>Description</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {reports.map((report, index) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        <Typography variant='body2' color="primary">
                                            {report.report}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>{report.description}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                :
               
                reports.map((report, i) =>
                    <Card variant="outlined" key={i} sx={{ marginBottom: 2 }}>
                        <CardContent>
                            <Stack spacing={1}>
                                <Typography variant="body2">
                                    <b>Report: </b>{report.report}
                                </Typography>
                                <Typography variant="body2">
                                    <b>Description: </b>{report.description}
                                </Typography>
                            </Stack>
                        </CardContent>
                    </Card>
    )}

        </Box>
    )
};

export default IndependentExpenditureTable;